/**
 * @generated SignedSource<<7945e0ac331a27cb7725788cbdc29783>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_spreadsheetView$data = {
  readonly viewSettings: {
    readonly groupByConfig: {
      readonly groupByField: {
        readonly fieldId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_ListView_spreadsheetView";
};
export type main_issueNavigator_ListView_spreadsheetView$key = {
  readonly " $data"?: main_issueNavigator_ListView_spreadsheetView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_spreadsheetView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_spreadsheetView",
  "selections": [
    {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroupByConfig",
          "kind": "LinkedField",
          "name": "groupByConfig",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraField",
              "kind": "LinkedField",
              "name": "groupByField",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "d27f8b285319e0114462be392b46dadd";

export default node;
